import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { useSettingsStore } from '@/state/useSettingsStore'

interface Props {
  data: Array<{ t: string; gained: number; lost: number }>
  height?: number
}

export function ChurnBar({ data, height = 200 }: Props) {
  const locale = useSettingsStore((s) => s.locale)
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} margin={{ top: 8, right: 8, left: 8, bottom: 0 }}>
        <CartesianGrid stroke="var(--border)" strokeDasharray="2 4" vertical={false} />
        <XAxis
          dataKey="t"
          axisLine={false}
          tickLine={false}
          stroke="var(--ink-subtle)"
          fontSize={11}
          tickFormatter={(iso) =>
            new Date(iso).toLocaleDateString(locale === 'cs' ? 'cs-CZ' : 'en-GB', {
              month: 'short',
            })
          }
        />
        <YAxis hide />
        <Tooltip
          cursor={{ fill: 'var(--surface-2)', fillOpacity: 0.4 }}
          contentStyle={{
            background: 'var(--surface-1)',
            border: '1px solid var(--border)',
            borderRadius: 12,
            fontSize: 12,
            color: 'var(--ink)',
          }}
        />
        <Bar dataKey="gained" stackId="a" fill="var(--signal-good)" radius={[6, 6, 0, 0]} />
        <Bar dataKey="lost" stackId="a" fill="var(--signal-bad)" radius={[6, 6, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  )
}
